import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import api from '../utils/httpClient';
import { createAsyncThunk } from '@reduxjs/toolkit';
import type { CallType } from '@nucleus-care/nucleuscare-connect-signaling';

interface ReportCallStartedOptions {
  CallLogID: string;
  RequestID?: string;
  PatientID: string;
  UserID: string;
  CallType?: string;
  DeviceID: string;
}

interface ReportMultiCallStartedOptions {
  CallLogID: string;
  UserID: string;
  ClassID?: string;
  PatientIDs?: string;
  DeviceIDs?: string;
  CallType?: string;
}

interface RequestCallPayload {
  PatientID: string;
  DeviceID?: string;
  IsEmergency?: boolean;
}

export const validateCallUrlPromise = (deviceIds: string[]) => {
  return api.post('/call/validate_call_url', {
    deviceIds,
  });
};

export const requestCallThunk = createAsyncThunk('communication/requestCall', async (params: RequestCallPayload) => {
  const response = await api.post(
    '/call/request_call',
    params, //serializeJSON({ ...params, IsEmergency: false }),
    { timeout: 20000 },
  );

  console.log('requestCall response', response.data);
  return response.data;
});

export async function requestCallPromise(body: RequestCallPayload) {
  const { data } = await api.post('/call/request_call', body, { timeout: 20000 });
  return data;
}

export async function reportCallStartedPromise(opts: ReportCallStartedOptions) {
  const { data } = await api.post('/v2/call/report_call_started', opts);
  return data;
}

export async function reportMultiCallStartedPromise(opts: ReportMultiCallStartedOptions) {
  const { data } = await api.post('/call/report_multi_call_started', opts);
  return data;
}

type ParticipantType = {
  deviceId: string;
  entityId: string;
};

export type CalleeEntity = {
  entityId: string;
  firstName?: string;
  lastName?: string;
  name: string;
  host: boolean;
  status: string;
  type: CallType;
};

export type FullCallEntity = {
  entityId: string;
  devicesIds: string[];
} & CalleeEntity;

export type WebRTCCall = {
  requestId: string;
  callLogId?: string;
  userId?: string;
  patientId: string;
  patientName: string;
  userName?: string;
  patientFirstName: string;
  patientLastName: string;
  participants: FullCallEntity[];
  entityId?: string;
  patientThumb: string;
  type: CallType;
  callerName?: string;
  calleeFirstName?: string;
  calleeLastName?: string;
  multiCall: boolean | null;
  classParticipants?: any[];
  classSessionId?: string;
  // We use the device name when calling a single device
  deviceName?: string;
  callingMethod: 'Call' | 'Notify';
  timeoutInSeconds?: number;
};

export type CallInitialState = {
  entityId?: string;
  loudestPeer: string | null;
  participants: ParticipantType[];
  type: 'Video' | 'Audio' | 'Instant' | 'SilentInstant';
  requestCall: false;
  call?: WebRTCCall;
  callParticipantsStatus?: any;
  callParticipantsVideoSizes?: any;
	
};
const initialState: CallInitialState = {
  loudestPeer: null,
  participants: [],
  type: 'Video',
  requestCall: false,
};

const callSlice = createSlice({
  name: 'callSlice',
  initialState: initialState,
  reducers: {
    startCall(state, action) {
      console.log('startCall', action.payload);
      state.call = action.payload;
      state.callParticipantsStatus = {};
      state.callParticipantsVideoSizes = {};
      return state;
    },
    onCallEvent(state, action) {
      console.log('onCallEvent', action.payload);
      state.callParticipantsStatus[action.payload.peerId] = {
        ...state.callParticipantsStatus[action.payload.peerId],
        status: action.payload.status,
      };
      return state;
    },
    onCallPeerVideoSize(state, action) {
      console.log('onCallPeerVideoSize', action.payload);
      state.callParticipantsVideoSizes[action.payload.peerId] = {
        ...state.callParticipantsVideoSizes[action.payload.peerId],
        ratioFactor: action.payload.ratioFactor,
      };
      return state;
    },
    endCall(state) {
      state.call = undefined;
      return state;
    },
    setLoudestPeer(state, action: PayloadAction<string>) {
      state.loudestPeer = action.payload;
    },
  },
});

export const { startCall, onCallEvent, onCallPeerVideoSize, endCall, setLoudestPeer } = callSlice.actions;
export default callSlice;
